import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QuestionnaireService } from '../questionnaire.service';
import { NavigationService } from '@base/shared/services';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'eyrus-questionnaire-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.sass']
})
export class QuestionnairePreviewComponent implements OnInit {

  questionaireForm: FormGroup;
  questionnaire: Array<any> = [];
  questionnaireType: String = 'generalQuestionnaire';

  constructor(
    private formBuilder: FormBuilder,
    private questionnaireService: QuestionnaireService,
    private navigation: NavigationService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.bootstrapForm({});

    this.questionnaire = this.questionnaireService.questionnaire;

    this.questionnaireType = this.route.snapshot.data.questionnaireType;

    if (!this.questionnaire || !this.questionnaire.length) {
      this.navigation.navigate({
        type: 'basic',
        stepParams: 1
      });
      return;
    }

    const _questions = {};
    this.questionnaire.forEach((question, i) => {

      const questionField = `question${i}`;
      const answer = this.getAnswerField(question.questionTypeConst);
      _questions[questionField] = [
        question[answer], [Validators.required]
      ];
      question.questionField = questionField;
    });

    this.bootstrapForm(_questions);
  }

  goBack() {
    this.navigation.navigate({
      type: 'basic',
      stepsBack: 1
    });
  }

  /**
 * Initialize Questionaire form
 */
  private bootstrapForm(items) {
    this.questionaireForm = this.formBuilder.group(items);
  }

  /**
 * get answer key for the anwser
 */
  private getAnswerField(type: string) {
    let _key = 'answerText';
    switch (type) {
      case 'text':
        _key = 'answerText';
        break;
      case 'number':
        _key = 'answerNumber';
        break;
      case 'dropdown':
      case 'radio':
        _key = 'answerText';
        break;
    }

    return _key;
  }

}
